import { Box } from "@/Components/v2/atoms/Box";
import { Typography } from "@/Components/v2/atoms/Typography";
import { OutlinedButton } from "@/Components/v2/atoms/Button";
import { Add } from "@mui/icons-material";
import { useTheme } from "@mui/material";
import ActionPlansBackgroundDark from "@/pages/scenario-builder/images/ActionPlansBackgroundDark.png";
import { Stack } from "@/Components/v2/atoms/Stack";

type NoActionPlansProps = {
  onClick: () => void;
};

const NoActionPlansCTA = ({ onClick }: NoActionPlansProps) => {
  const theme = useTheme();
  return (
    <Box
      sx={{
        borderRadius: "1rem",
        padding: "2.8rem",
        backgroundColor: theme.palette.actionPlans.ctaBackground,
        alignItems: "left",
        textAlign: "left",
        position: "relative",
        overflow: "hidden",
      }}
    >
      <Stack sx={{ paddingRight: "388px" }} spacing={2} alignItems="left">
        <Typography variant="h6" fontWeight={600}>
          You haven&apos;t created an Action Plan yet
        </Typography>
        <Typography variant="body2">
          Bridge the gap between forecasting and execution with Action Plans.
        </Typography>
        <Typography variant="body2">
          Set a goal, then track your spend and revenue against it over time. Each data refresh
          gives you updated spend recommendations to ensure you hit your targets.
        </Typography>
        <Typography variant="body2">
          To begin, choose an existing scenario to convert into an Action Plan.
        </Typography>
        <OutlinedButton startIcon={<Add />} onClick={onClick}>
          New Action Plan
        </OutlinedButton>
      </Stack>
      <img
        src={ActionPlansBackgroundDark}
        alt="Action Plans Background"
        width="348px"
        style={{
          position: "absolute",
          right: "2.8rem",
          top: "2.8rem",
          borderRadius: "4px 4px 0px 0px",
        }}
      />
    </Box>
  );
};

export default NoActionPlansCTA;
